// extracted by mini-css-extract-plugin
export default {"container":"qsFBWd","error-details":"vXlU7O","error-details-trigger":"w0ZdIq","error-detail-cards-container":"iaLEbS"};